<script>
  import { onMount, afterUpdate, createEventDispatcher } from "svelte";
  import { router } from 'tinro';
  import request from 'superagent';
  import Comment from "./Comment.svelte";
  import Link from "./Link.svelte";
  import Video from "./Video.svelte";
  import CommentForm from './form/Comment.svelte';
  import ItemForm from './form/Item.svelte';
  import LinkForm from './form/Link.svelte';
  import VideoForm from './form/Video.svelte';
  import { Dropdown, DropdownItem, DropdownMenu, DropdownToggle } from 'sveltestrap';
  
  
  const defaultLink = { id: null, language: "cz", title: "", uri: "" }
  const defaultVideo = { id: null, provider: '', slug: null, language: "cz", title: "", uri: "", about: "", image: "", channel_name: ""}
  const defaultVideoPlayer = {player: null, visible_video_player: 1, video_slug: null};
  const defaultItem = { id: null, videos: [], links: [], comments: [], rating: 0, video_player: defaultVideoPlayer};
  const dispatch = createEventDispatcher();
  const LINKS_CONTENT = 1;
  const VIDEOS_CONTENT = 2;
  const ITEMS_CONTENT = 3;
  
  const DOMAIN_GROUPING = 1;
  const DATE_GROUPING = 2;
  
  export let id = null;
  export let item = Object.assign({}, defaultItem);
  export let user = null;
  export let item_form_id = null;
  export let link_form_id = window.LINK_FORM_ID;
  export let url_prefix = '';
  export let api_prefix = '';
  
  $: item = Object.assign({}, defaultItem, item || {}), !('exists' in item) && getItem();
  
  let unsavedLinksCount = 0;
  let unsavedVideosCount = 0;
  
  let visible_content = LINKS_CONTENT;
  let visible_grouping_menu = false;
  
  let grouping = null;
  let grouped_links = {};
  
  let sorting = 0;
  let sorted_groups = [];
  
  $: {
    /*if (item['exists'] && $router.path != $router.from) {
      id = $router.path.replace('/n/', '');
      item['exists'] =  false;
      console.log(id)
    }*/
    if (grouping == DOMAIN_GROUPING) {
      sorted_groups =  Object.keys(grouped_links).sort((a, b) => sorting ? b.localeCompare(a) : a.localeCompare(b));
    } else if (grouping == DATE_GROUPING) {
      sorted_groups =  Object.keys(grouped_links).map((s) => dateToI(s)).sort((a, b) => sorting ? a[0]-b[0] : b[0]-a[0]).map((s) => s[1]);
    } else {
      sorted_groups =  [];
    }
  }
  
  window.onYouTubeIframeAPIReady = function() {
      // first video
  }
  
  function toggleSorting() {
    sorting = !sorting;
    switch (grouping) {
      case 1:
        groupLinksByDomain(); break;
      case 2:
        groupLinksByDate(); break;
      default:
      // TODO sort item.links
    }
  }
  
  function cancelGrouping() {
    grouped_links = {};
    grouping = null;
  }
  
  function playVideo(ev) {
    //item.video_player['visible_video_player'] = true
  
    item.video_player['video_slug'] = ev.detail;
    setTimeout(() => {
      item.video_player['player'] = new YT.Player('player-'+item.id, {
          events: {
              'onReady': (event) => { event.target.playVideo(); },
              'onStateChange': (event) => {
                  if (event.data == YT.PlayerState.ENDED) {
                    for (let i = 0; i < item.videos.length; i++) {
                      if (item.videos[i].slug == item.video_player.video_slug && i + 1 != item.videos.length) {
                        playVideo({detail: item.videos[i+1].slug});
                        break;
                      }
                    }
                  }
              }
          }
      });
    }, 100)
  }
  
  function getItem(forced_id) {
    if (forced_id && forced_id != id) {
      visible_content = LINKS_CONTENT
      item = Object.assign({}, defaultItem)
      id = forced_id
    }
    if (item['exists'])
      return;
    item.id = id;
    fetch(`${api_prefix}/${window.atob(item.id)}.json`)
      .then(r => r.json())
      .then(data => {
        item = Object.assign(item, defaultItem, data);
        item.exists = !!item.id;
        window.scrollTo(0, 0);
        dispatch('item', Object.assign({}, defaultItem, item));
        visible_content = item.links.length ? LINKS_CONTENT : VIDEOS_CONTENT;
  
        if (item.video_to_play) {
          playVideo({detail:item.video_to_play.slug});
          item.video_player['visible_video_player'] = true;
          showVideos();
          item.video_to_play = null;
        }
      })
      .catch(resp => {
        console.log("error when getting item")
      });
  }
  
  /*function getComments() {
    fetch(`/c/${window.atob(id)}.json`)
      .then(r => r.json())
      .then(data => {
        item.comments = data.data;
    });
  }*/
  
  function addComment(event) {
    comment = event.detail;
    comment.user = user
    item.comments.push(comment)
    toggleEditor();
  }
  
  function showLinks() {
    visible_content = LINKS_CONTENT;
    if (!('links' in item))
      item['links'] = [];
    if (user && !item.links.length)
      addLink();
  }
  
  function showVideos() {
    visible_content = VIDEOS_CONTENT;
    if (!('videos' in item))
      item['videos'] = [];
    if (user && !item.videos.length)
      addVideo();
  }
  
  function showSubitems() {
    visible_content = ITEMS_CONTENT;
    if (!('subitems' in item))
      item['subitems'] = [];
  }
  
  function takeLink(link) {
    item.links[0] = link.detail;
    unsavedLinksCount--;
  }
  
  function addLink() {
    item.links = [Object.assign({}, defaultLink), ...item.links];
    unsavedLinksCount++;
    visible_content = LINKS_CONTENT;
  }
  
  function removeLink(index) {
    if (!item.links[index].id) unsavedLinksCount--;
    let tmp = item.links
    tmp.splice(index, 1)
    item.links = tmp
  }
  
  function takeVideo(r) {
    item.videos[0] = r.detail;
    unsavedVideosCount--;
  }
  
  function addVideo() {
    item.videos = [Object.assign({}, defaultVideo), ...item.videos];
    unsavedVideosCount++;
    visible_content = VIDEOS_CONTENT;
  }
  
  function removeVideo(index) {
    if (!item.videos[index].id) unsavedVideosCount--;
    let tmp = item.videos
    tmp.splice(index, 1)
    item.videos = tmp
  }
  
  function like() {
    request.post(`/rate/item/${window.atob(id)}.jsr`)
      .then(resp => {
        if (resp.statusCode == 200)
          item.rating++;
        else if (resp.statusCode == 204)
          item.rating--;
      })
      .catch(resp => {
        console.log("error when LIKING")
      });
  }
  
    let dateToI = function(s) {
      var d = s.split("/");
      return [(new Date( d[2], d[1]-1, d[0])).getTime(), s];
    }
  
  function groupLinksByDomain() {
    grouped_links = {};
    for (var group = "", i = 0; i < item.links.length; i += 1) {
      let r = item.links[i].uri.match(/^(\w+:\/\/)?(.[^/]+)/);
      if (r !== null && r.length >= 3)
        group = r[2];
  
      if (!grouped_links[group])
        grouped_links[group] = [];
      grouped_links[group].push(item.links[i]);
    }
  
    for (var group in grouped_links) {
      grouped_links[group] = grouped_links[group].sort((o,p) => sorting ? o.id - p.id : p.id - o.id);
    }
    grouping = DOMAIN_GROUPING;
  }
  
  function groupLinksByDate() {
    grouped_links = {};
    for (var group = "", i = 0; i < item.links.length; i += 1) {
      group = item.links[i].created_at.substr(6);
  
      if (!grouped_links[group])
        grouped_links[group] = [];
      grouped_links[group].push(item.links[i]);
    }
  
    for (var group in grouped_links) {
      grouped_links[group] = grouped_links[group].sort((o,p) => sorting ? o.id - p.id : p.id - o.id);
    }
    grouping = DATE_GROUPING;
  }
  
  function init() {
    if (item == null)
      getItem();
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  }
  
  onMount(init)
  
  export function dragover(ev) {
    ev.preventDefault();
    ev.dataTransfer.dropEffect = 'move';
  }
  
  export function dropFromPost(ev) {
    ev.preventDefault();
    var post = JSON.parse(ev.dataTransfer.getData("text"));
    if ("video_id" in post) {
      item.videos = [Object.assign({}, defaultVideo, post), ...item.videos];
      unsavedVideosCount++;
      visible_content = VIDEOS_CONTENT;
    } else {
      item.links = [Object.assign({}, defaultLink, post), ...item.links];
      unsavedLinksCount++;
    }
  }
</script>
<article class='d-flex flex-column rounding-1' on:dragover='{dragover}' on:drop='{event => dropFromPost(event)}' style='min-height: 70%'>
<section class='meta text-muted d-flex flex-row justify-content-between px-0 badge badge-light badge-lg pl-1'>
<span>
{#if item.created_at}{item.created_at}{/if}
</span>
&nbsp;&nbsp;
<span on:click='{like}' on:keyup='{like}'>
{item.rating}
<i class:far='{true}' class:fas='{false}' class='fa-star'></i>
</span>
{#if item.user}
<span>
{item.user}
</span>
{/if}
</section>
<div class='border-0 bg-white'>
<div class='d-flex justify-content-between flex-column'>
<h2 class='pl-1 my-3'>
{#if item.title}{item.title}{/if}
</h2>
{#if item.about}
<section class='about'>
{@html item.about}
</section>
{/if}
{#if item.video_player && item.video_player.visible_video_player && item.video_player.video_slug}
<iframe title="Video" id="player-{item.id}"  width="100%" height="400" src="https://www.youtube.com/embed/{item.video_player.video_slug}?enablejsapi=1" frameborder="0" allowfullscreen autoplay="1" />
{/if}
</div>
<nav class='mt-3 px-1'>
<ul class='nav nav-tabs'>
<li class='nav-item flex-sm-fill' on:click='{showLinks}' on:keyup='{showLinks}'>
<div class:active='{visible_content == LINKS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
odkazy
</div>
{#if user}
<small class:d-none='{visible_grouping_menu}' class='btn btn-outline-primary border-0' disabled='{grouping}' on:click='{addLink}' on:keyup='{addLink}'>
<i class='fa fa-plus'></i>
</small>
{/if}
<Dropdown isOpen='{visible_grouping_menu}' toggle='{() => visible_grouping_menu = !visible_grouping_menu}'>
<DropdownToggle caret class='border-0' color='link' outline>
{#if visible_grouping_menu}
Seskupení
{:else}
<i class='fa fa-layer-group'></i>
{/if}
</DropdownToggle>
<DropdownMenu>
<DropdownItem disabled='{!grouping}' on:click='{cancelGrouping}' on:keyup='{cancelGrouping}'>
zrušit
</DropdownItem>
<DropdownItem on:click='{groupLinksByDomain}' on:keyup='{groupLinksByDomain}'>
podle zdroje
</DropdownItem>
<DropdownItem on:click='{groupLinksByDate}' on:keyup='{groupLinksByDate}'>
podle dní
</DropdownItem>
</DropdownMenu>
</Dropdown>
<button class:d-none='{visible_grouping_menu}' class='btn btn-outline-link border-0' disabled='{!grouping}' on:click='{toggleSorting}' on:keyup='{toggleSorting}'>
<i class:fa-sort-numeric-down='{!sorting}' class:fa-sort-numeric-up='{sorting}' class='fa'></i>
</button>
</div>
</li>
<li class='nav-item flex-sm-fill' on:click='{showVideos}' on:keyup='{showVideos}'>
<div class:active='{visible_content == VIDEOS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
videa
</div>
{#if user}
<small class='btn btn-outline-primary border-0' on:click='{addVideo}' on:keyup='{addVideo}'>
<i class='fa fa-plus'></i>
</small>
{/if}
</div>
</li>
<li class='nav-item flex-sm-fill' on:click='{showSubitems}' on:keyup='{showSubitems}'>
<div class:active='{visible_content == ITEMS_CONTENT}' class='nav-link flex-row d-flex'>
<div class='btn btn-outline-link border-0'>
souvislosti
</div>
</div>
</li>
</ul>
</nav>
<ol class='links list-group list-group-flush pl-1'>
{#if visible_content == ITEMS_CONTENT}
{#each item.subitems as subitem, i}
<li class='list-group-item border-0 pl-1 py-3'>
{#if subitem.tag != null}
<h4 class='mb-0'>
{subitem.tag}
</h4>
{/if}
<h6 class='mb-1 pl-1'>
<a href='/n/{subitem.subitem_id}' on:click='{()=>getItem(subitem.subitem_id)}'>
{subitem.title}
</a>
</h6>
{#if subitem.about}
<div class='text-muted'>
{subitem.about}
</div>
{/if}
</li>
{/each}
{:else if visible_content == VIDEOS_CONTENT}
{#each item.videos as video, i}
<li class='list-group-item border-0 pl-0 pt-2'>
{#if video.id != null || video.from_feed }
<Video on:playVideo='{playVideo}' video='{video}'></Video>
{:else}
<div class='m-1'>
<VideoForm item_id='{item.id}' on:remove='{() => removeVideo(i)}' on:video='{takeVideo}' show_label='{i==0}' video='{video}'></VideoForm>
</div>
{/if}
</li>
{/each}
{#if item.videos.length == 0}
<li class='list-group-item border-0 pl-0 pt-2'>
<div class='alert alert-secondary p-1 mt-3 text-center'>
Žádná videa.
</div>
</li>
{/if}
{:else}
{#if grouping}
{#each sorted_groups as group}
<li class='list-group-item border-0 pl-0 pt-2'>
<div class='card border-0'>
<div class='card-body'>
<div class='card-title'>
{#if grouping == DOMAIN_GROUPING}
<span class='pl-4' style='background: url(http://www.google.com/s2/favicons?domain={group}) left center no-repeat'>
{group}
</span>
{:else}
{group}
{/if}
</div>
{#each grouped_links[group] as link, i}
{#if link.id}
<Link link='{link}' link_id='{link.id}'></Link>
{/if}
{/each}
</div>
</div>
</li>
{/each}
{:else}
{#each item.links as link, i}
<li class='list-group-item border-0 pl-0 pt-2'>
{#if link.id}
<Link link='{link}' link_id='{link.id}'></Link>
{:else}
<div class='m-1'>
<LinkForm form_id='{link_form_id}' item_id='{item.id}' link='{link}' on:link='{takeLink}' on:remove='{() => removeLink(i)}' show_label='{i==0}'></LinkForm>
</div>
{/if}
</li>
{/each}
{/if}
{/if}
</ol>
</div>
</article>

